// Import JS
import VanillaTilt from 'vanilla-tilt';
import '@/js/scripts.ts';

// Import CSS
import '@/app.css';

// Alpinejs init - Delay to prevent FOUC --------------------------
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'

// Configure Alpine plugins
Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.plugin(intersect)

// Make Alpine available globally
// @ts-ignore
window.Alpine = Alpine

// Start Alpine after DOM is loaded and styled to prevent FOUC
function initAlpine() {
    Alpine.start()
    // Mark Alpine as ready
    document.documentElement.classList.add('alpine-loaded')
}

// Wait for DOM and fonts to be ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAlpine)
} else {
    // DOM already loaded, start immediately
    initAlpine()
}


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    // @ts-ignore
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}